import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'diagnostic-level',
    components: {

    },
})

export default class DiagnosticLevel extends Vue {

    // -----------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private updateConfig: any = {};

    private categoryList: any = [];

    private selectedCategory: any = null;

    private selectDropdown: any = new Array(7).fill({}).map((item, index) => item.value = index);

    // -----------------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.fetchCategoryLists();
    }

    // -----------------------------------------------------------------------------------
    // Actions

    private onSelectConfig() {
        this.$emit('onChangeConfig', this.updateConfig);
    }

    private onSelectCategory(category: any) {
        this.selectedCategory = category;
        this.subjectLists(category);
    }

    private onSelectSubject(event: any, subject: any) {
        const childElement: any = (event.target.parentElement as HTMLElement).querySelector('.framework-blk');
        this.$el.querySelectorAll('.framework-blk').forEach((element) => {
            if (element !== event) {
                (element as HTMLElement).style.display = 'none';
            }
        });
        (childElement as HTMLElement).style.display = (childElement as HTMLElement).style.display === 'block' ? 'none' : 'block';
    }


    // ---------------------------------------------------------------------------------
    // Methods

    private subjectLists(category: any) {
        taxonomyAPI.fetchSubjects(category.id).then((subjects) => {
            this.$set(this.selectedCategory, 'subjectList', subjects);
            // this.selectedCategory.subjectList = subjects;
         });
     }

     private fetchCategoryLists() {
         taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
               this.categoryList = classification;
         });
     }

    // private parseConfig() {
    //     let framework = this.levels.find((item: any) => item.name === 'frameworks').selectedContent;
    //     let subject = this.levels.find((item: any) => item.name === 'subjects').selectedContent;
    //     return (this.selectedConfig.tenantConfig.value || {}, {
    //         [framework.code+'.'+subject.code]: 0
    //     })
    // }

    // private activeSubjectCode() {
    //     let subject = this.levels.find((item: any) => item.name === 'subjects').selectedContent;
    //     return subject.code;
    // }
}
